import cx from "classnames";
import React from "react";
// import { pipe } from 'fp-ts/lib/function';
// import * as O from 'fp-ts/lib/Option';
import { Img, SvgStaticImage } from "@gromia/components/SvgStaticImage";
import * as s from "@gromia/components/theme/t.module.css";
import * as spriv from "./VerticalIconsSteps.module.css";

type StepProps = {
  title: NonNullable<React.ReactNode>;
  text: NonNullable<React.ReactNode>;
  icon: Img;
};

export function VerticalStep(props: StepProps) {
  return (
    <li className={cx(spriv.step)}>
      <div className={cx(spriv.icon)}>
        <SvgStaticImage src={props.icon} alt="" />
      </div>
      <div className={cx(spriv.content)}>
        <h3
          className={cx(
            s.textDark,
            s.fontWeightBold,
            s.fontSizeLgLarge2,
            s.fontSizeLarge1,
          )}
        >
          {props.title}
        </h3>
        <p
          className={cx(
            s.mb0,
            s.textMuted,
            s.fontSizeLgBig,
            s.fontSizeSmBase,
            s.fontSizeSmall1,
          )}
        >
          {props.text}
        </p>
      </div>
    </li>
  );
}

type StepsProps = {
  children: Array<React.ReactElement<StepProps>>;
};

export function VerticalSteps(props: StepsProps) {
  return (
    <ul className={cx(spriv.steps)}>
      {React.Children.map(props.children, x => React.cloneElement(x))}
    </ul>
  );
}
